<template>
  <v-container fluid>
    <h1 class="display-inline">Forecast: Staff Planned Hours</h1>
    <div class="display-inline ml-3">
      <ActiveApiCalls/>
    </div>

    <PipelineGraph></PipelineGraph>
    <StaffWorkload></StaffWorkload>

  </v-container>
</template>

<script>


import PipelineGraph from "@/components/capacity/PipelineGraph.vue"
import ActiveApiCalls from "@/components/tools/ActiveApiCalls.vue";
import StaffWorkload from "@/components/capacity/StaffWorkload.vue";

export default {
  name: "ReportPipelinePage",
  permissions: [...PipelineGraph.permissions,  ...ActiveApiCalls.permissions, ...StaffWorkload.permissions],
  components: {ActiveApiCalls, PipelineGraph, StaffWorkload},
  data() {
    return {}
  },
  mounted() {

  },
}

</script>

<style scoped>

</style>